import { useDispatch } from 'react-redux';
import { setLogoutCheck } from '../redux/slices/interfaceSlice';
import { setCookie } from '../utils/cookies';
import { useNavigate } from 'react-router-dom';
import { useState, useMemo } from 'react';
import { useGetClientQuery } from '@/queries/useGetClientQuery';

export const useHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutDialogOpen, setLogoutDialogOpen] = useState<boolean>(false);
  const { data: clientData, isPending, error } = useGetClientQuery();

  const userName = useMemo(() => {
    if (clientData) return `${clientData.name} ${clientData.last_name}`;

    return '';
  }, [clientData]);

  const handleLogout = () => {
    dispatch(setLogoutCheck(true));
    setCookie('isAuth', 'false');
    localStorage.clear();
    navigate('/login');
  };

  return { logoutDialogOpen, handleLogout, setLogoutDialogOpen, userName };
};
